/* Calvora — PDP Video Carousel */
(function () {
  if (customElements.get('cv-video-carousel')) return;

  var SVG = {
    close: '<svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round"><path d="M18 6 6 18M6 6l12 12"/></svg>',
    prev: '<svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"><path d="m15 18-6-6 6-6"/></svg>',
    next: '<svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"><path d="m9 18 6-6-6-6"/></svg>'
  };

  var ICON_MUTED = '<svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"><path d="M11 5 6 9H2v6h4l5 4V5Z"/><path d="m23 9-6 6M17 9l6 6"/></svg>';
  var ICON_SOUND = '<svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"><path d="M11 5 6 9H2v6h4l5 4V5Z"/><path d="M15.5 8.5a5 5 0 0 1 0 7"/><path d="M19 5a9 9 0 0 1 0 14"/></svg>';

  class CvVideoCarousel extends HTMLElement {
    connectedCallback() {
      this.track = this.querySelector('[data-cvv-track]');
      this.items = Array.from(this.querySelectorAll('[data-cvv-clip]'));
      this.videos = Array.from(this.querySelectorAll('[data-cvv-video]'));
      this.autoplay = this.dataset.autoplay !== 'false';
      this.openMode = this.dataset.openMode || 'popup';
      this.current = 0;

      this.setupArrows();
      this.setupAutoplay();
      this.setupClicks();
      this.setupSound();
    }

    setupArrows() {
      var self = this;
      var prev = this.querySelector('[data-cvv-prev]');
      var next = this.querySelector('[data-cvv-next]');
      if (!this.track) return;

      function step(dir) {
        var item = self.items[0];
        var w = item ? item.getBoundingClientRect().width + 16 : 200;
        self.track.scrollBy({ left: dir * w * 2, behavior: 'smooth' });
      }

      if (prev) prev.addEventListener('click', function () { step(-1); });
      if (next) next.addEventListener('click', function () { step(1); });

      function updateState() {
        if (!prev || !next) return;
        var max = self.track.scrollWidth - self.track.clientWidth - 2;
        prev.disabled = self.track.scrollLeft <= 2;
        next.disabled = self.track.scrollLeft >= max;
      }

      this.track.addEventListener('scroll', updateState, { passive: true });
      window.addEventListener('resize', updateState);
      updateState();
    }

    setupAutoplay() {
      if (!this.autoplay || !this.videos.length) return;
      var saveData = navigator.connection && navigator.connection.saveData;
      var reduce = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
      if (saveData || reduce || !('IntersectionObserver' in window)) return;

      var io = new IntersectionObserver(function (entries) {
        entries.forEach(function (entry) {
          var v = entry.target;
          if (entry.isIntersecting) {
            if (v.dataset.src && !v.getAttribute('src')) v.src = v.dataset.src;
            var p = v.play();
            if (p && p.catch) p.catch(function () {});
          } else {
            v.pause();
          }
        });
      }, { threshold: 0.35 });

      this.videos.forEach(function (v) { io.observe(v); });
      this.io = io;
    }

    setupSound() {
      var self = this;
      this.querySelectorAll('[data-cvv-sound]').forEach(function (btn) {
        btn.addEventListener('click', function (e) {
          e.preventDefault();
          e.stopPropagation();
          var clip = btn.closest('[data-cvv-clip]');
          var v = clip && clip.querySelector('[data-cvv-video]');
          if (!v) return;
          v.muted = !v.muted;
          btn.setAttribute('aria-pressed', String(!v.muted));
          btn.innerHTML = v.muted ? ICON_MUTED : ICON_SOUND;
          if (!v.muted) {
            self.videos.forEach(function (other) { if (other !== v) other.muted = true; });
          }
        });
      });
    }

    setupClicks() {
      var self = this;
      this.items.forEach(function (clip, index) {
        clip.addEventListener('click', function (e) {
          var href = clip.dataset.url;
          if (self.openMode === 'link' && href) {
            window.location.href = href;
            return;
          }
          e.preventDefault();
          self.openModal(index);
        });
      });

      document.addEventListener('keydown', function (e) {
        if (!self.modal || !self.modal.classList.contains('is-open')) return;
        if (e.key === 'Escape') self.closeModal();
        if (e.key === 'ArrowRight') self.showIndex(self.current + 1);
        if (e.key === 'ArrowLeft') self.showIndex(self.current - 1);
      });
    }

    buildModal() {
      var self = this;
      var modal = document.createElement('div');
      modal.className = 'cvv-modal';
      modal.setAttribute('role', 'dialog');
      modal.setAttribute('aria-modal', 'true');
      modal.innerHTML =
        '<div class="cvv-modal__box">' +
        '<button type="button" class="cvv-modal__close" aria-label="Close">' + SVG.close + '</button>' +
        '<button type="button" class="cvv-modal__prev" aria-label="Previous">' + SVG.prev + '</button>' +
        '<button type="button" class="cvv-modal__next" aria-label="Next">' + SVG.next + '</button>' +
        '<video playsinline controls loop preload="metadata"></video>' +
        '<a class="cvv-modal__cta" hidden></a>' +
        '</div>';

      modal.addEventListener('click', function (e) { if (e.target === modal) self.closeModal(); });
      modal.querySelector('.cvv-modal__close').addEventListener('click', function () { self.closeModal(); });
      modal.querySelector('.cvv-modal__prev').addEventListener('click', function () { self.showIndex(self.current - 1); });
      modal.querySelector('.cvv-modal__next').addEventListener('click', function () { self.showIndex(self.current + 1); });

      document.body.appendChild(modal);
      this.modal = modal;
      this.modalVideo = modal.querySelector('video');
      this.modalCta = modal.querySelector('.cvv-modal__cta');
      return modal;
    }

    openModal(index) {
      if (!this.modal) this.buildModal();
      this.modal.classList.add('is-open');
      document.body.style.overflow = 'hidden';
      this.videos.forEach(function (v) { v.pause(); });
      this.showIndex(index);
    }

    closeModal() {
      if (!this.modal) return;
      var self = this;
      this.modal.classList.remove('is-open');
      document.body.style.overflow = '';
      this.modalVideo.pause();
      this.modalVideo.removeAttribute('src');
      this.modalVideo.load();
      this.videos.forEach(function (v) {
        var r = v.getBoundingClientRect();
        if (self.autoplay && r.top < window.innerHeight && r.bottom > 0) {
          var p = v.play();
          if (p && p.catch) p.catch(function () {});
        }
      });
    }

    showIndex(index) {
      var total = this.items.length;
      if (!total) return;
      this.current = (index + total) % total;

      var clip = this.items[this.current];
      var src = clip.dataset.videoSrc || '';
      var poster = clip.dataset.poster || '';
      var url = clip.dataset.url || '';
      var cta = clip.dataset.cta || '';
      var v = this.modalVideo;

      v.poster = poster;
      if (src) {
        v.src = src;
        v.muted = false;
        v.currentTime = 0;
        var p = v.play();
        if (p && p.catch) {
          p.catch(function () { v.muted = true; v.play().catch(function () {}); });
        }
      } else {
        v.removeAttribute('src');
        v.load();
      }

      if (url && cta) {
        this.modalCta.href = url;
        this.modalCta.textContent = cta;
        this.modalCta.hidden = false;
      } else {
        this.modalCta.hidden = true;
      }
    }
  }

  customElements.define('cv-video-carousel', CvVideoCarousel);
})();
